import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

import { IdentityConstants } from '@auth';
import { SasDynamicFormService } from '../sas-dynamic-form.service';
import { FormSubmittedService } from '@services';

@Component({
    selector: 'sas-input-password-field-type',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule],
    template: `
        <div class="form-group mb-3">
            <label [for]="field.id"
                [id]="field.id + 'Label'"
                [title]="field.props['helptext'] | translate"
                class="form-label"
                [textContent]="field.props.label"
                translate="{{field.props.label}}">
            </label>
            @if (field.props.required) {
                <span> *</span>
            }
            <div [id]="field.id + 'Help'" [title]="field.props['helptext'] | translate" class="sas-inline-block">
                @if (field.props['helptext']) {
                <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
                }
            </div>
            <div class="sas-pw-field">
                <i class="bi bi-lock-fill sas-pw-field__lock" aria-hidden="true"></i>
                <input [type]="showPassword ? 'text' : 'password'"
                    [name]="field.name"
                    class="form-control"
                    [ngClass]="{'is-invalid': isInvalid}"
                    [id]="field.id"
                    [attr.sas-id]="field.id"
                    [formControl]="formControl"
                    placeholder="{{field.props.placeholder! | translate}}"
                    maxlength="{{field.props.maxLength}}"
                    autocomplete="new-password"
                    tabindex="0"
                    required="{{field.props.required}}"
                    [pattern]="pattern"
                    [attr.aria-labelledby]="field.id + 'Label'"
                    [attr.aria-required]="field.props.required"
                    [attr.aria-describedby]="field.id + 'Help'"/>
                <button type="button"
                        class="sas-pw-field__toggle"
                        [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                        (click)="togglePasswordVisibility()">
                    <i [class]="showPassword ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'" aria-hidden="true"></i>
                </button>
            </div>
            <div [id]="field.id + 'Desc'" role="alert" aria-atomic="true" class="invalid-feedback">
                <small>{{ sasDynamicFormService.getFieldErrorMessage(field) }}</small>
            </div>
        </div>
    `,
    styleUrl: './sas-input-password-field-type.component.scss'
})
export class SasInputPasswordFieldTypeComponent extends FieldType<FieldTypeConfig> {
    formSubmittedService = inject(FormSubmittedService);
    identityConstants = inject(IdentityConstants).identityConstants;
    sasDynamicFormService = inject(SasDynamicFormService);

    pattern = this.identityConstants.regexPatternPasswordEnhanced;
    showPassword = false;

    get isInvalid() {
        return this.field.formControl.invalid && (this.field.formControl.dirty || this.formSubmittedService.isSubmitted())
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    ngOnInit() {
        this.pattern = this.field.props['validation']?.pattern || this.identityConstants.regexPatternPasswordEnhanced;
        if (this.field.props['validation'] && !this.field.props['validation'].patternText) {
            this.field.props['validation'].patternText = 'VALIDATION_PASSWORD_ERROR';
        }
    }
}
